module.exports = __webpack_public_path__ + "img/man-in-saleshat@2x.201c061.webp";